define.alias("shared/components/shared/media-item-modal", "calendar/components/shared/media-item-modal");